import {
  Box,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  History as HistoryIcon,
  Update as UpdateIcon,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";
import GlobalHeader from "../../components/header";

export default function HistorialDeVersiones() {
  return (
    <>
      <GlobalHeader />
      <Box sx={{ p: 3 }}>
        <Typography
          variant="h4"
          sx={{ display: "flex", alignItems: "center", mb: 2 }}
        >
          <HistoryIcon sx={{ mr: 1 }} /> Historial de versiones
        </Typography>
        <List>
          <ListItem>
            <ListItemIcon>
              <CheckCircleIcon color="success" />
            </ListItemIcon>
            <ListItemText
              primary="Versión 1.1.0 SW PollosTeo"
              secondary="Fecha de lanzamiento: 23 de Abril de 2025. Incluye mejoras en el rendimiento y corrección de errores menores."
            />
          </ListItem>
          <Divider component="li" />
          <ListItem>
            <ListItemIcon>
              <UpdateIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Versión 1.0.0 SW PollosTeo"
              secondary="Fecha de lanzamiento: 19 de febrero de 2025. Primera versión oficial del software."
            />
          </ListItem>
        </List>
      </Box>
    </>
  );
}
